import { getFavouriteColumns } from "api/column";
import { getUserSetting } from "api/userSettings";

import { EntityKind } from "models/entityKind";

import {
  DEFAULT_FACILITY_FOCUS_TILES_SETTING,
  DEFAULT_FOCUS_TILES_SETTING
} from "components/user-settings/constants/userSetting.constants";
import { DefaultFocusTiles } from "components/user-settings/models";

import { toFocusTileProperties } from "./toFocusTileProperties";

// What the user's focus tiles resolve to server-side (personal, else org), else favourites.
export const resolveFocusTiles = async (
  entityKind: EntityKind
): Promise<DefaultFocusTiles> => {
  const settingKey =
    entityKind === EntityKind.Well
      ? DEFAULT_FOCUS_TILES_SETTING
      : DEFAULT_FACILITY_FOCUS_TILES_SETTING;
  const resolved = await getUserSetting<DefaultFocusTiles>(settingKey);
  if (resolved) return { id: resolved.id, tiles: resolved.tiles };

  const favourites = await getFavouriteColumns(entityKind);
  return { tiles: toFocusTileProperties(favourites.data) };
};
